import React, { useState } from "react";
import "./Ceodb.scss";

const DemographicComparator = () => {
    const [activeTab, setActiveTab] = useState("statement");

    const tableData = [
        {
            dimension: "Respect",
            statement: "I am able to take time off from work when I think it's necessary.",
            score: 42
        },
        {
            dimension: "Respect",
            statement: "People here are treated fairly regardless of their gender.",
            score: 49
        },
        {
            dimension: "Credibility",
            statement: "My Organization shows a sincere interest in me as a person, not just an employee.",
            score: 41
        },
        {
            dimension: "Credibility",
            statement: "I can be myself around here.",
            score: 36
        }
    ];

    return (
        <div className="statement-preview-page">
            {/* Top Header */}
            <div className="top-bar">
                <div className="tabs">
                    <button
                        className={activeTab === "statement" ? "active" : ""}
                        onClick={() => setActiveTab("statement")}
                    >
                        Statement
                    </button>
                    <button
                        className={activeTab === "dimension" ? "active" : ""}
                        onClick={() => setActiveTab("dimension")}
                    >
                        Dimension
                    </button>
                </div>

                <div className="actions">
                    <select>
                        <option>Please Select Benchmark</option>
                    </select>
                    <button className="download-btn">
                        Download Statement Scores
                    </button>
                </div>
            </div>

            {/* Filters */}
            <div className="filters">
                <div>
                    <label>Select Dimension:</label>
                    <select>
                        <option>ALL</option>
                    </select>
                </div>

                <div>
                    <label>Select Demographic:</label>
                    <select>
                        <option>Location</option>
                    </select>
                </div>

                <div>
                    <label>Select Options:</label>
                    <select>
                        <option>Select...</option>
                    </select>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Dimension</th>
                            <th>Statement</th>
                            <th className="right">Overall</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((row, index) => (
                            <tr key={index}>
                                <td>{row.dimension}</td>
                                <td>{row.statement}</td>
                                <td className="score">{row.score}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DemographicComparator;